// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ITagResponse {
  /** Значение тега **/
  type: EType;
  /** Текст тега **/
  title: string;
  /** Количество отзывов по данному тегу **/
  count: number;
  /** Есть ли активный фильтр по данному тегу **/
  isSelected: boolean;
}

export enum EType {
  /** Инфраструктура **/
  'Infrastructure' = 'infrastructure',
  /** Придомовая территория **/
  'Adjoining_territory' = 'adjoining_territory',
  /** Транспортная доступность **/
  'Transport_affordable' = 'transport_affordable',
  /** Дом **/
  'House' = 'house',
  /** Парковка **/
  'Parking' = 'parking',
  /** Отделка **/
  'Flat' = 'flat',
  /** Дети **/
  'Kids' = 'kids',
  /** Строительство **/
  'Construction' = 'construction',
  /** Покупка **/
  'Purchase' = 'purchase',
  /** Район **/
  'District' = 'district',
  /** управляющая компания **/
  'Management_company' = 'management_company',
  /** Застройщик **/
  'Developer' = 'developer',
}
